import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ButtonsGroupContainer,
  InitialFlexedHeader,
  MenuItem,
  MenuItemsContainer,
  Wrapper,
  ButtonPlaceholder,
  InitialLogo,
  DesktopMenuItem,
  BookmarkIconLink,
  LargeCreateItemLink,
  PashaMenuItem,
  PashaIconPlaceholder
} from './styled';
import Plus from '../../public/static/images/green-plus.svg';
import { LinkWithIcon } from '../LinkWithIcon';
import { SEARCH_RESULT_ROUTES } from '../../utils/helpers/constants';
import { StyledLogoIcon } from '../HamburgerMenu/styled';
import WhitePlusInCircle from '../../public/static/images/icon-plus-in-circle--white.svg';
import { InitialLoginButton } from '../LoginButton/InitialLoginButton';
import { TooltipWrapper } from '../ui/Tooltip/styled';
import FavoriteIcon from '../../public/static/images/favorite-transparent.svg';

export const InitialFlexibleHeader = () => {
  const { t } = useTranslation();

  return (
    <InitialFlexedHeader data-cy="header" id="header">
      <Wrapper>
        <InitialLogo href="/">
          <ButtonPlaceholder className="link" />
          <StyledLogoIcon
            data-cy="header-menu-logo"
            data-stat="header-menu-logo"
            alt="logo"
            width={85}
            height={20}
          />
        </InitialLogo>
        <MenuItemsContainer>
          <MenuItem
            href={SEARCH_RESULT_ROUTES.SALE}
            className="link"
            prefetch={false}
          >
            {t('main_menu.sale')}
          </MenuItem>
          <MenuItem
            href={SEARCH_RESULT_ROUTES.RENT}
            className="link"
            prefetch={false}
          >
            {t('main_menu.lease')}
          </MenuItem>
          <MenuItem
            href={SEARCH_RESULT_ROUTES.RENT_DAILY}
            className="link"
            prefetch={false}
          >
            {t('search.form.paid_daily')}
          </MenuItem>
          <DesktopMenuItem
            href="/agentlikler"
            className="link"
            prefetch={false}
          >
            {t('main_menu.agencies')}
          </DesktopMenuItem>
          <DesktopMenuItem
            href="/yasayis-kompleksleri"
            className="link"
            prefetch={false}
          >
            {t('main_menu.residences')}
          </DesktopMenuItem>
          <PashaMenuItem href="/pasha" className="link">
            <PashaIconPlaceholder />
            PASHA Real Estate
          </PashaMenuItem>
        </MenuItemsContainer>
        <ButtonsGroupContainer>
          <TooltipWrapper>
            <BookmarkIconLink
              href="/bookmarks"
              aria-label={t('pages.bookmarks.title')}
              className="link"
            >
              <FavoriteIcon />
            </BookmarkIconLink>
          </TooltipWrapper>
          <LargeCreateItemLink href="/items/new">
            <WhitePlusInCircle />
            {t('common.create_new_item')}
          </LargeCreateItemLink>
          <LinkWithIcon
            cypress="add-new-icon-btn"
            href="/items/new"
            stat="header-btn"
            icon={Plus}
            width={30}
            height={30}
            indent={false}
            className="small-add-link"
          />
          <InitialLoginButton />
        </ButtonsGroupContainer>
      </Wrapper>
    </InitialFlexedHeader>
  );
};
